<template>
  <div class="v-select-text-truncate">

    <v-select
      :items="colorItems"
      :label="colorLabel"
      outline
      menu-props="auto"
      item-text="name"
      :value="realColorValue"
      return-object
      :single-line="singleLine"
      @input="setColor"
      :hide-details="isArtStep"
    >
      <template slot="selection" slot-scope="data">
        <div class="select-swatch-selection d-flex align-items-center">
          <swatch :color="data.item"></swatch>
          <span class="select-swatch-item-text ml-2">{{ data.item.name }}</span>
        </div>
      </template>
      <template slot="item" slot-scope="data">
        <div class="select-swatch-item">
          <swatch :color="data.item"></swatch>
          <span class="select-swatch-item-text ml-2">{{ data.item.name }}</span>
        </div>
      </template>
    </v-select>

  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import Swatch from '../components/Swatch'
  import Color from '../utils/color'
  import _get from 'lodash/get'
  import _clone from 'lodash/clone'

  export default {
    props: ['colors', 'colorValue', 'colorRequired', 'showLabel', 'isPrintColor', 'rowPosition', 'isGlobal', 'label', 'hideLabelOnMobile', 'singleLine'],
    data () {
      return {
        uuid: this.$uuid.v4()
      }
    },
    components: {
      'swatch': Swatch
    },
    computed: {
      colorItems () {
        let items = this.colors
        if (this.isPrintColor && !this.customband.isPrinted()) {
          items = [...[{ id: 0, name: 'None' }], ...this.colors]
        }
        return items
      },
      colorLabel () {
        return this.label ? this.label : 'Color'
      },
      realColorValue () {
        let colorId = _get(this.colorValue, 'id', false)
        if (colorId === false) {
          return this.colorItems[0]
        }
        return this.colorValue
      },
      realColorValueId () {
        return _get(this.colorValue, 'id', false)
      },
      colorsNotEmpty () {
        return this.colors.filter(color => color.hasOwnProperty('id') && color.id)
      },
      isArtStep () {
        return this.$route.name === 'bandbuilder.silicone.graphics'
      },
      ...mapState([
        // map this.customband to store.state.customband
        'customband'
      ])
    },
    methods: {
      setColor (color) {
        // Insert path into the color
        let newColor = _clone(color)
        newColor._path = this.colorValue._path
        this._setColor(newColor)
      },
      removePrintColor () {
        let newColor = new Color({ _path: this.colorValue._path })
        this._setColor(newColor)
      },
      _setColor (newColor) {
        if (this.isPrintColor) {
          let payload = {
            color: newColor,
            isGlobal: this.isGlobal,
            rowPosition: this.rowPosition
          }
          this.$store.dispatch('customband/setPrintColor', payload)

          if (this.customband.isDualLayer()) {
            this.$root.$data.fixedPreview.renderProduct()
          } else {
            this.$root.$data.fixedPreview.renderAreas()
          }
        } else {
          this.$store.commit('customband/setColor', newColor)

          this.$root.$data.fixedPreview.renderProduct()
        }

        this.$store.dispatch('customband/checkCompletion')
      },
      ...mapActions('customband', [

      ])
    },

    created () {
      // console.log('this.colorValue.id', this.colorValue.id)
      // console.log('this.colors', this.colors)
      // console.log('ColorSelect this', this)
      // console.log('this.showLabel', this.showLabel)
      // console.log('this.label', this.label)
      // console.log('this.realColorValue', this.realColorValue)
    }
  }
</script>
